import { useState, useEffect, useMemo } from "react";

type DebounceFunction<T extends (...args: any[]) => any> = (
  func: T,
  delay: number
) => (...args: Parameters<T>) => void;

export const vtDebounce: DebounceFunction<any> = (func, delay) => {
  let timeoutId: NodeJS.Timeout;

  return (...args: Parameters<any>) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};